export const STOCK_SEARCH_INTERVAL = 500;
export const CATALOGUE_IMAGE_MAXIMUM_SIZE = 1500000;
export const CATALOGUE_IMAGE_MINIMUM_SIZE = 1;
export const ATTRIBUTE_IMAGE_MAX_SIZE = 1000000;
export const ATTRIBUTE_IMAGE_MIN_SIZE = 100;
